import { render, staticRenderFns } from "./DomainPrivateWhoisEnableModal.vue?vue&type=template&id=7b7d17c2&"
import script from "./DomainPrivateWhoisEnableModal.vue?vue&type=script&lang=js&"
export * from "./DomainPrivateWhoisEnableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports